import { ICurrentUser } from "@models/user-management/user";

export enum AuthProviderEnum {
  AzureAD = "AzureAD",
  Okta = "Okta",
}

export interface IAuthStrategy {
  getCurrentUser(): Promise<ICurrentUser | null>;
  isUserSignedIn(): Promise<boolean>;
  getToken(): Promise<string | undefined>;
  userInitiatedSignOut(): Promise<void>;
  getUserRoles(): Promise<string[] | undefined>;
}
